export const URL = "https://dev.support.africasystems.com"; //https://admin.africsys.com/  http://localhost:8098/ http://localhost:8068 http://localhost:8019 http://localhost:8096
export const DATABASE = "support_erp_db"; //lewoo_db_1 afrisyserp as_db_2
export const loginA = "paved.ngoune@africasystems.com";
export const loginUrl = `${URL}/auth/request/lewootrack/token`;
export const registerUrl = `${URL}/lewootrack/register_user`;
export const contactUsUrl = `${URL}/lewootrack/submit_contact_us`;
export const subscriptionUrl = `${URL}/lewootrack/submit_subscription`;
export const getDataUrl = `${URL}/lewootrack/get_data`;
export const getPackages = `${URL}/lewootrack/get_packages`;
export const getPageUrl = `${URL}/lewootrack/my_page`;
export const getQuotationUrl = `${URL}/lewootrack/my_quotation`;
export const getPurchaseOrderUrl = `${URL}/lewootrack/my_purchase_order`;
export const getInvoiceBillsUrl = `${URL}/lewootrack/my_invoice_bill`;
export const getRequestsUrl = `${URL}/lewootrack/requests`;
export const METHOD_POST = "POST";
export const METHOD_GET = "GET";



export const LOCAL_URL_DEV = "https://dev.support.africasystems.com";
const headersDev = new Headers();
headersDev.append('api-key', "Y1ZPPWYA7240ACT27P5MZNISUHB8KX8H")
headersDev.append('token', "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJsb2dpbiI6ImFkbWluQGFmcmljYXN5c3RlbXMuY29tIiwidWlkIjoyfQ.6xsEW-0sso5zckj-jP4Jgxi9N5IWjIpZnFR0UUFFS5k")



export const LOCAL_URL = "https://africasystems.com";
const headers = new Headers();
headers.append('api-key', "SJ46U61QW74R7CD31KUQV642JQCZ5UBC")
headers.append('token', "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJsb2dpbiI6ImFmcmljc3lzQGFmcmljc3lzLmNvbSIsInVpZCI6MzV9.-H-YYDNDt4t944qo_twlJJBHqHoTe59JoOkBXifOa0o")

const headers1 = new Headers();
headers1.append('authorization', "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJsb2dpbklkIjoxMTcyLCJ1c2VybmFtZSI6ImVuZW90cmFjayIsInJvbGVzIjoiQ0xJRU5UIiwiaWF0IjoxNzI4NTU0NDcxfQ.g4WzrK9Lu2UODOyKBF6VAclJan-ySCXnDCOvN18Jqgg")
headers1.append('token', "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJsb2dpbiI6ImFmcmljc3lzQGFmcmljc3lzLmNvbSIsInVpZCI6MzV9.-H-YYDNDt4t944qo_twlJJBHqHoTe59JoOkBXifOa0o")






export async function postData(url, { arg }) {
    console.log("request URL", url);
    console.log("request arg", JSON.stringify(arg));
    return fetch(url, {
        headers: headers,
        method: METHOD_POST,
        body: JSON.stringify(arg)
    }).then((res) => {
        // console.log("mauvaise reponse", res);
        if (res.ok) {
            return res.json()
        } else {
            console.log("mauvaise reponse", res);
        }
    })
}
export async function deleteData(url, { arg }) {
    console.log("request URL", url);
    console.log("request arg", JSON.stringify(arg));
    return fetch(url, {
        headers: headers,
        method: 'DELETE',
    }).then((res) => {
        // console.log("mauvaise reponse", res);
        if (res.ok) {
            return res.json()
        } else {
            console.log("mauvaise reponse", res);
        }
    })
}
export async function putData(url, { arg }) {
    console.log("request URL", url);
    console.log("request arg", JSON.stringify(arg));
    return fetch(url, {
        headers: headers,
        method: "PUT",
        body: JSON.stringify(arg)
    }).then((res) => {
        // console.log("mauvaise reponse", res);
        if (res.ok) {
            return res.json()
        } else {
            console.log("mauvaise reponse", res);
        }
    })
}


export async function getData(url) {
    // console.log("request URL", url);
    return fetch(url, {
        headers: headers,
        method: 'GET',
    }).then((res) => {
        if (res.ok) {

            return res.json()
        } else {
            console.log("mauvaise reponse", res);

        }
    })
}
export async function getData1(url) {
    // console.log("request URL", url);
    return fetch(url, {
        headers: headers1,
        method: 'GET',
    }).then((res) => {
        if (res.ok) {

            return res.json()
        } else {
            console.log("mauvaise reponse", res);

        }
    })
}
export async function getDataBold(url) {
    // console.log("request URL", url);
    return fetch(url, {
        headers: headers,
        method: 'GET',
    }).then((res) => {
        if (res.ok) {
            console.log("res......dddddd", res);

            return res.blob()
        } else {
            console.log("mauvaise reponse", res);

        }
    })
}



export const odooFetch = (url, req) => {
    return fetch(url, req);
};

export const odooData = (
    url,
    method,
    formData,
    headers,
    onSuccess,
    onError
) => {
    var req = {
        method: method,
        headers: headers,
    };
    if (method == "POST") req["body"] = formData;
    // console.log('headers -- ', headers)
    // console.log('url -- ', url)
    odooFetch(url, req)
        .then((response) => response.json())
        .then((result) => {
            console.log(result)
            if (result && result.success === 1) {
                if (onSuccess) {
                    onSuccess(result);
                }
            } else {
                if (onError) {
                    onError(result?.message);
                }
            }
        })
        .catch((error) => {
            console.log("error -- ==", error);
            if (onError) {
                onError("1");
            }
        });
};

export const formDataBody = (fields) => {
    var formData = new FormData();
    formData.append("ID", "1");
    Object.keys(fields).forEach((key) => {
        if (fields[key]) {
            formData.append(key, fields[key]);
        }
    });
    // console.log("formData -- ", formData);
    return formData;
};

export const getHeaders = (token) => {
    var myHeaders = new Headers();
    if (token) myHeaders.append("Authorization", "Bearer " + token);
    return myHeaders;
};      
